// extracted by mini-css-extract-plugin
export var card = "_90-1";
export var container = "_90-0";